import {List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import {type IPaymentMethod} from './model';

const paymentMethodsReducer = makeReducer(
    [match(Actions.fetchPaymentMethodsSuccess, (state, {payload}) => payload.paymentMethods)],
    List<IPaymentMethod>(),
);

export default paymentMethodsReducer;
